import { Component, OnInit } from "@angular/core";
import { AccountService } from "../../models/account.service";
import { RememberService } from "../../remember/remember.service";

@Component({
  selector: "ab-rate-limit-alert",
  templateUrl: "./rate-limit.component.html",
})
export class RateLimitAlertComponent implements OnInit {
  public show: boolean;
  private REMEMBER_KEY = "alerts.rateLimit.hide";

  constructor(
    private accountService: AccountService,
    private rememberService: RememberService,
  ) {}

  public close() {
    this.rememberService.set(this.REMEMBER_KEY, true);
    this.show = false;
  }

  public ngOnInit() {
    this.show = false;

    if (this.rememberService.get(this.REMEMBER_KEY, false)) {
      return;
    }

    this.accountService.properties().subscribe((props: any) => {
      this.show = props.alerts ? props.alerts.rate_limit_alert === true : false;
    });
  }
}
